module.exports = __webpack_public_path__ + "img/roulette-card-clubs.c52278ea.svg";